var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "files" },
    [
      _c(
        "div",
        { staticClass: "files__wrapper" },
        _vm._l(_vm.files, function (file) {
          return _c("file-preview", {
            key: file.id || file.url,
            staticClass: "file",
            attrs: {
              type: _vm.getFileType(file.url),
              url: file.url,
              name: file.name,
              actions: _vm.actions,
              "show-video": _vm.showVideo,
              "full-width": _vm.fullWidth,
            },
            on: {
              click: function ($event) {
                return _vm.showGallery(file)
              },
            },
          })
        }),
        1
      ),
      _c("FsLightbox", {
        attrs: {
          toggler: _vm.lightbox,
          sources: _vm.gallery,
          slide: _vm.slide,
          "disable-local-storage": true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }